import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  KPI_OPTIMAL_BADGE_COLOR,
  KPI_CAUTION_BADGE_COLOR,
  KPI_CRITICAL_BADGE_COLOR,
} from '../../../../themes/tokens';

const PREVIOUS_BAR_COLOR = '#B3C0B5';

export const CustomLegend = ({ tooltipPreviousCopy }: { tooltipPreviousCopy?: string }) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" p={1}>
      <Box display="flex" alignItems="center" mb={0.5}>
        <Box width={10} height={'1.5px'} bgcolor="black" mr={1} />
        <Typography fontSize={'10px'} textTransform={'uppercase'}>
          {t('dashboard.benchmark')}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" mb={0.5}>
        <Box width={10} height={10} bgcolor={PREVIOUS_BAR_COLOR} mr={1} />
        <Typography fontSize={'10px'} textTransform={'uppercase'}>
          {tooltipPreviousCopy || t('dashboard.previous')}
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" mb={0.5} ml={0}>
        <Typography fontSize={'10px'} textTransform={'uppercase'} mt={0}>
          {t('dashboard.yourSalon')}:
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" mb={0.5} ml={1}>
        <Box width={10} height={10} bgcolor={KPI_OPTIMAL_BADGE_COLOR} mr={1} />
        <Typography fontSize={'10px'} textTransform={'uppercase'}>
          {t('dashboard.aboveBenchmark')}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" mb={0.5} ml={1}>
        <Box width={10} height={10} bgcolor={KPI_CAUTION_BADGE_COLOR} mr={1} />
        <Typography fontSize={'10px'} textTransform={'uppercase'}>
          {t('dashboard.atBenchmark')}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" ml={1}>
        <Box width={10} height={10} bgcolor={KPI_CRITICAL_BADGE_COLOR} mr={1} />
        <Typography fontSize={'10px'} textTransform={'uppercase'}>
          {t('dashboard.belowBenchmark')}
        </Typography>
      </Box>
    </Box>
  );
};
